<template>

<div class="text-2 inner">

    <div class="text-2-text ecc" v-html="item.text" />

</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.text-2 {
    padding: 0px 10px;
}

.text-2-text {
    text-align: center;
}

</style>
